<template>
  <div>
    <DriverListing />
  </div>
</template>

<script>
import DriverListing from "@/components/Drivers/listing/DriverListing.vue";
export default {
  components: { DriverListing },
};
</script>
